import React from "react";
import PropTypes from "prop-types";
import helpers from "helpers/base";

class ControlledCheckbox extends React.Component {
  static propTypes = {
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    noLabel: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    label: null,
    noLabel: false,
    value: "1"
  };

  constructor(props) {
    super(props);

    this.inputId = helpers.generateComponentUuid("checkbox");

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      checked: props.checked
    };
  }

  renderLabel() {
    const { children, label, noLabel } = this.props;

    if (noLabel) {
      return null;
    }

    return (
      <label className="lc-checkbox__label" htmlFor={this.inputId}>
        {label || children}
      </label>
    );
  }

  handleChange(e) {
    this.setState(
      (prevState) => ({ checked: !prevState.checked }),
      () => {
        this.props.onChange && this.props.onChange(e);
      }
    );
  }

  render() {
    return (
      <div className="lc-checkbox">
        <input
          className="lc-checkbox__input"
          checked={this.props.checked}
          disabled={this.props.disabled}
          id={this.inputId}
          name={this.props.name}
          onChange={this.handleChange}
          type="checkbox"
          value={this.props.value}
        />
        {this.renderLabel()}
      </div>
    );
  }
}

export default ControlledCheckbox;
